import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import './style.css';

import L from 'leaflet';

import { loadPlaces } from './data.js';
import { createMap } from './map.js';
import { createFilters } from './filters.js';

const statusEl = document.getElementById('status');

function setStatus(message, isError = false) {
  statusEl.textContent = message || '';
  statusEl.classList.toggle('status--error', isError);
  statusEl.classList.toggle('status--hidden', !message);
}

/** Human-friendly message for a GeolocationPositionError (or generic Error). */
function geoErrorMessage(err) {
  switch (err.code) {
    case 1:
      return 'Location permission denied.';
    case 2:
      return 'Your location is currently unavailable.';
    case 3:
      return 'Timed out while finding your location.';
    default:
      return err.message || 'Could not determine your location.';
  }
}

/** Add a Leaflet control button that locates the user via the browser. */
function addLocateControl(map, locateUser) {
  const LocateControl = L.Control.extend({
    options: { position: 'topleft' },
    onAdd() {
      const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control locate-control');
      const button = L.DomUtil.create('a', '', container);
      button.href = '#';
      button.title = 'Show my location';
      button.setAttribute('role', 'button');
      button.setAttribute('aria-label', 'Show my location');
      button.innerHTML = '◎';

      L.DomEvent.disableClickPropagation(container);
      L.DomEvent.on(button, 'click', (e) => {
        L.DomEvent.preventDefault(e);
        if (button.classList.contains('locate-control--busy')) return;

        button.classList.add('locate-control--busy');
        setStatus('Finding your location…');
        locateUser()
          .then(() => setStatus(''))
          .catch((err) => setStatus(geoErrorMessage(err), true))
          .finally(() => button.classList.remove('locate-control--busy'));
      });

      return container;
    },
  });

  map.addControl(new LocateControl());
}

async function init() {
  setStatus('Loading places…');

  const { map, render, locateUser } = createMap('map');

  addLocateControl(map, locateUser);

  let places;
  try {
    places = await loadPlaces();
  } catch (err) {
    console.error(err);
    setStatus(`Could not load places: ${err.message}`, true);
    return;
  }

  createFilters({
    container: document.getElementById('filters'),
    places,
    onChange: render,
  });

  setStatus('');

  // Mobile: toggle the filter panel open/closed, with a tappable backdrop.
  const toggle = document.getElementById('filters-toggle');
  const filtersPanel = document.getElementById('filters');
  const backdrop = document.getElementById('filters-backdrop');

  function setFiltersOpen(open) {
    filtersPanel.classList.toggle('filters--open', open);
    backdrop.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
  }

  toggle.addEventListener('click', () => {
    setFiltersOpen(!filtersPanel.classList.contains('filters--open'));
  });
  backdrop.addEventListener('click', () => setFiltersOpen(false));
}

init();
